var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 3.5C4.75 2.80964 5.30964 2.25 6 2.25H10C10.6904 2.25 11.25 2.80964 11.25 3.5V4.25H4.75V3.5ZM12.75 3.5V4.25H15C15.4142 4.25 15.75 4.58579 15.75 5C15.75 5.41421 15.4142 5.75 15 5.75H12H4H1C0.58579 5.75 0.25 5.41421 0.25 5C0.25 4.58579 0.58579 4.25 1 4.25H3.25V3.5C3.25 1.98122 4.48122 0.75 6 0.75H10C11.5188 0.75 12.75 1.98122 12.75 3.5ZM2 16.5V7.5C2 6.94772 2.44772 6.5 3 6.5H13C13.5523 6.5 14 6.94772 14 7.5V16.5C14 18.1569 12.6569 19.5 11 19.5H5C3.34315 19.5 2 18.1569 2 16.5ZM6 10C6.2761 10 6.5 10.2239 6.5 10.5V15.5C6.5 15.7761 6.2761 16 6 16C5.72386 16 5.5 15.7761 5.5 15.5V10.5C5.5 10.2239 5.72386 10 6 10ZM10 10C10.2761 10 10.5 10.2239 10.5 10.5V15.5C10.5 15.7761 10.2761 16 10 16C9.7239 16 9.5 15.7761 9.5 15.5V10.5C9.5 10.2239 9.7239 10 10 10Z",
    fill: "#EF2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.74fe5677e0c99d87a8c48b291f721546.svg";
export { ForwardRef as ReactComponent };